// تابع کمکی برای parse کردن tags
export function parseTags(tags) {
  if (!tags) {
    return [];
  }
  
  if (typeof tags === 'string') {
    try {
      const parsed = JSON.parse(tags);
      if (Array.isArray(parsed)) {
        return parsed;
      }
    } catch (error) {
      // اگر JSON parse نشد، به عنوان string با کاما جدا کنیم
      return tags.split(',').map(tag => tag.trim()).filter(tag => tag);
    }
  } else if (Array.isArray(tags)) {
    return tags;
  }
  
  return [];
}

// تابع کمکی برای تبدیل tags به string
export function tagsToString(tags) {
  if (!Array.isArray(tags)) {
    return '';
  }
  return tags.join(', ');
}






